module.exports = __webpack_public_path__ + "static/media/stamp_13.3bd4ed3c.png";